
/**
 * Plugin Pinia pour réinitialiser tous les stores
 * Ajoute une méthode $reset() au rootStore qui réinitialise tous les stores
 */
export function resetPlugin({ store, pinia }) {
    // Ajouter une propriété au store racine pour réinitialiser tous les stores
    return {
        // Ajoute une méthode $resetAll au rootStore
        $resetAll() {
            // Pour chaque store dans pinia.state.value
            const initialState = pinia.state.value[store.$id];
            store.$patch(initialState);
        }
    };
}

/**
 * Plugin Pinia pour persister certains états dans le localStorage
 * Utilisé pour les stores qui nécessitent une persistance entre les rafraichissements
 */
export function persistStatePlugin({ store }) {
    // Définir quels stores et quels états sont persistés
    const persistedStores = {
        auth: ['token', 'user', 'company'],
        // Ajoutez d'autres stores et états à persister si nécessaire
    };

    // Vérifier si ce store doit être persisté
    const shouldPersist = persistedStores[store.$id];

    if (!shouldPersist) return {};

    // Charger les données persistantes depuis localStorage
    const savedState = JSON.parse(localStorage.getItem(`pinia-${store.$id}`)) || {};

    // Restaurer les données dans le store
    if (Object.keys(savedState).length > 0) {
        store.$patch(savedState);
    }

    // S'abonner aux changements d'état pour les sauvegarder dans localStorage
    store.$subscribe((mutation, state) => {
        const stateToPersist = {};

        // Ne sauvegarder que les propriétés configurées pour ce store
        persistedStores[store.$id].forEach(key => {
            if (state[key] !== undefined) {
                stateToPersist[key] = state[key];
            }
        });

        localStorage.setItem(`pinia-${store.$id}`, JSON.stringify(stateToPersist));
    });

    return {
        // Ajouter des propriétés ou méthodes supplémentaires si nécessaire
    };
}